<template>
  <v-card width="400" class="conf-card ma-2"
    :raised="isActive" :elevation="dndCallOver ? 14 : 3"
    @dragover.prevent="dragOver" @dragleave.prevent="dragLeave"
    @drop.prevent="dndDrop">
    <v-card-title primary-title :class="headerClasses">
      <span>{{ conf.name }}</span>
      <v-spacer></v-spacer>
      <CardTitleMenu :has-calls="hasCalls"
        :can-call="canCall"
        :can-invite="canInvite"
        @call-room="$emit('call-room')"
        @invite-member="$emit('invite-member')"
        @show-members="showMembers" />
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row dense class="text-no-wrap">
        <v-col md="6">
          <v-icon small>mdi-card-account-phone</v-icon>
          {{ $t('confr.exten') }}: {{ conf.exten }}
        </v-col>
        <v-col md="6">
          <v-icon small>mdi-account-switch</v-icon>
          {{ $t('confr.capacity') }}: {{ conf.maxusers }} members
        </v-col>
        <v-col md="6" v-show="userPin">
          <v-icon small>mdi-lock</v-icon>
          {{ $t('confr.pin') }}: {{ userPin }}
        </v-col>
        <v-col md="6" class="conf-member">
          <v-icon small>mdi-account-multiple-check</v-icon>
          {{ $t('confr.members') }}: {{ memNum }}
        </v-col>
        <v-col md="6" v-show="adminPin">
          <v-icon small>mdi-lock-outline</v-icon>
          {{ $t('confr.adminpin') }}: {{ adminPin }}
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog v-model="confirmXferDlg" persistent max-width="400px">
      <v-card>
        <v-card-title class="title" primary-title>
          <v-icon large class="mr-3" color="primary">mdi-phone-forward</v-icon>
          {{$t('sipua.xfer.title')}} &lt;{{conf.exten}}&gt;?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="xferDo(false)" text>{{$t('sipua.xfer.cancel')}}</v-btn>
          <v-btn @click="xferDo(true)" text color="primary">{{$t('sipua.xfer.confirm')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardTitleMenu from './card_title_menu'
export default {
  name: 'conf-card',
  data () {
    return {
      dndCallOver: false,
      confirmXferDlg: false,
      xferCallId: '',
      xferNumber: ''
    }
  },
  props: {
    conf: {
      type: Object,
      required: true
    }
  },
  components: { CardTitleMenu },
  computed: {
    ...mapGetters({
      activeRoom: 'conferences/activeRoom',
      canCallPermission: 'permissions/conferCanCall',
      canInvitePermission: 'permissions/conferCanInvite'
    }),
    canCall: function () {
      return this.canCallPermission(this.conf.id)
    },
    canInvite: function () {
      return this.canInvitePermission(this.conf.id)
    },
    iconColor: function () {
      return this.hasCalls
        ? 'green'
        : ''
    },
    memNum: function () {
      return this.conf.members?.length ?? 0
    },
    adminPin: function () {
      return this.conf.adminpin
    },
    userPin: function () {
      return this.conf.pin
    },
    hasCalls: function () {
      return this.memNum > 0
    },
    isActive: function () {
      return this.conf === this.activeRoom
    },
    headerClasses: function () {
      return {
        primary: this.isActive,
        'pt-3': true,
        'pb-2': true
      }
    }
  },
  methods: {
    ...mapActions({
      setActive: 'conferences/setActive',
      memPaneShow: 'conferences/memPaneShow',
      xferToConfr: 'sipua/xferToConfr'
    }),
    showMembers: function () {
      this.setActive(this.conf).then(() => {
        this.memPaneShow(true)
      })
    },
    dragOver: function (e) {
      if (e.dataTransfer.types.includes('call/json')) {
        this.dndCallOver = true
      }
    },
    dragLeave: function (e) {
      this.dndCallOver = false
    },
    dndDrop: function (e) {
      if (!this.dndCallOver) return
      const data = e.dataTransfer.getData('call/json')
      if (!data) {
        this.dbg('ERROR: Failed call x-fer. Missing drag-n-drop call json data')
        return
      }
      const call = JSON.parse(data)
      this.xferCallId = call.callid
      this.xferNumber = call.number
      this.dndCallOver = false
      this.confirmXferDlg = true
    },
    xferDo: function (confirmed) {
      if (confirmed) {
        this.xferToConfr({ callid: this.xferCallId, conference: this.conf })
      }
      this.confirmXferDlg = false
      this.xferCallId = ''
      this.xferNumber = ''
    }
  }
}
</script>

<style scoped>
</style>
